<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" @submit.prevent="save">
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
            <el-button type="success" icon="el-icon-document-checked" @click="excelDown">엑셀</el-button>
          </el-form-item>
        </div>
      </el-form>

      <div class="search-form">
        <el-form size="mini">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="12">
              <el-form-item label-width="0px">
                <el-row>
                  <el-col>
                    <el-col :span="5">
                      <el-select v-model="search.dtType">
                        <el-option value='' label="전체">전체</el-option>
                        <el-option
                            v-for="item in combos['dtType']"
                            :key="item.value"
                            :value="item.key"
                            :label="item.value">
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="9">
                      <el-date-picker type="date" placeholder="Pick a date" v-model="search.startDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-col>
                    <el-col :span="1" style="text-align: start;">-</el-col>
                    <el-col :span="9">
                      <el-date-picker type="date" placeholder="Pick a date" v-model="search.endDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="처리결과" label-width="100px">
                <el-col :span="16">
                  <el-select v-model="search.orderStatus">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['orderStatus']"
                        :key="item.value"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="상담원" label-width="100px">
                <el-col :span="17">
                  <el-select v-model="search.agentMember">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['agentMember']"
                        :key="item.value"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0px;">
            <el-col :span="12">
              <el-form-item label="주문자명" label-width="112px">
                <el-input type="text" v-model="search.custNm" @keyup.native.enter="goOpen" style="width: 45%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="입금은행" label-width="100px">
                <el-select v-model="search.payBank">
                    <el-option
                      v-for="item in combos['payBank']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                    </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="오늘의 할 일" label-width="100px">
                <el-checkbox type="text" true-label="Y" false-label="N"  v-model="search.chkToday"></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="inner-box">
      <div class="table-area">
        <div class="table-b">
          <div class="table-header">
            <div class="grid-tbl-box">
              <ag-grid-vue
                  ref="grid"
                  :style="gridStyle"
                  class="ag-theme-alpine"
                  :enableRangeSelection="true"
                  :column-defs="columnDefs"
                  :grid-options="mainGridOptions"
                  :row-data="data"
                  :default-col-def="defaultColDef"
                  :framework-components="frameworkComponent"
                  :statusBar="statusBar"
                  @grid-ready="onReadyMain"
                  @cell-clicked="onCellClicked" />
            </div>
          </div>
        </div>
      </div>

      <!-- 주문상품목록 그리드 s.-->
      <div class="table-area">
        <div class="table-b">
            <div class="table-header">
                <div class="table-name">
                    <h3 class="ico_table_name">{{ `주문상품목록` }}</h3>
                </div>
                <div class="btn-wrap btn-type1 clearfix">
                    <button class="btn-size btn-gray fl_right" @click="btnItemDelete" v-show="authEditable">
                      <span class="btn-icon">
                          <i class="fas fa-save"></i>
                      </span>
                      삭제
                    </button>&nbsp;
                    <button class="btn-size btn-gray fl_right" @click="btnItemAdd" v-show="authEditable">
                      <span class="btn-icon">
                          <i class="fas fa-save"></i>
                      </span>
                      추가
                    </button>
                </div>
                
                <div class="grid-tbl-box">
                    <ag-grid-vue 
                        ref="subGrid" 
                        :style="gridStyle"
                        class="ag-theme-alpine"
                        :enableRangeSelection="true"
                        :column-defs="subColumnDefs"
                        :grid-options="subGridOptions"
                        :context="context"
                        :row-data="subData"
                        :default-col-def="defaultColDef"
                        :framework-components="frameworkComponent"
                        @grid-ready="onReadySub"
                        @cell-value-changed="SubCellValueChange"
                        />
                </div>

                <div class="grid-tbl-box" v-show="false">
                    <ag-grid-vue 
                        ref="excelGrid" 
                        :style="gridStyle"
                        class="ag-theme-alpine"
                        :enableRangeSelection="true"
                        :column-defs="excelColumnDefs"
                        :grid-options="excelGridOptions"
                        :row-data="excelData"
                        :default-col-def="defaultColDef"
                        :framework-components="frameworkComponent"
                        @grid-ready="onReadyExcel"
                        />
                </div>
            </div>
        </div>
      </div>
      <!-- 주문상품목록 그리드 e.-->

      <!-- 결제방법 선택 form s.-->
      <div class="table-area">
            <div class="table-b">
                <div class="el-search-form">

                    <el-form size="mini" label-width="80px">
                        <el-row :gutter="24">
                            <el-col :span="12">
                                <div class="sub-title">
                                    <div class="table-name">
                                        <h3 class="ico_table_name">{{ `결제방법` }}</h3>
                                    </div>
                                </div>
                                <el-row :gutter="24">
                                    <el-col :span="12">
                                        <el-form-item label="주문번호">
                                            <el-input type="text" v-model="form.orderId" readonly></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="청구금액">
                                            <el-input type="text" v-model="form.orderAmt" readonly></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="24">
                                    <el-col :span="12">
                                        <el-form-item label="주문일시">
                                            <el-input type="text" v-model="form.createDt" readonly></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="입금일자">
                                            <el-input type="text" v-model="form.payConfirmDt" readonly></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="24">
                                    <el-col :span="12">
                                        <el-form-item label="주문자명">
                                            <el-input type="text" v-model="form.custNm" readonly></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-row>
                                            <el-form-item label="입금은행">
                                                <el-col :span="24">
                                                    <el-select v-model="form.payBank" :disabled="form.payYn==='N'">
                                                        <el-option
                                                          v-for="item in combos['payBank']"
                                                          :key="item.value"
                                                          :value="item.key"
                                                          :label="item.value">
                                                        </el-option>
                                                    </el-select>
                                                </el-col>
                                            </el-form-item>
                                        </el-row>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="24">
                                    <el-col :span="12">
                                        <el-form-item label="연락처">
                                            <el-input type="text" v-model="form.orderTelNo"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-row>
                                          <el-col :span="18">
                                            <el-form-item label="계산서발행">
                                              <el-radio-group v-model="form.billYn">
                                                  <el-radio 
                                                    v-for="item in combos['billYn']"
                                                    :key="item.key"
                                                    :label="item.key"
                                                    :value="item.key">{{ item.value }}
                                                  </el-radio>
                                              </el-radio-group>
                                            </el-form-item>
                                          </el-col>
                                          <el-col :span="6">
                                            <el-button size="mini" type="primary" icon="el-icon-search" @click="btnBillWrite">
                                              발행정보등록
                                            </el-button>
                                          </el-col>
                                        </el-row>
                                    </el-col>
                                </el-row>
                                <div class="grid-content bg-purple"></div>
                            </el-col>
                            <el-col :span="12">
                                <div class="sub-title">
                                    <div class="table-name">
                                        <h3 class="ico_table_name">{{ `배송지` }}</h3>
                                    </div>
                                </div>
                                <el-row>
                                    <el-col>
                                        <el-form-item label="받을사람">
                                            <el-input type="text" v-model="form.deliveryNm"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="24">
                                    <el-col :span="12">
                                        <el-form-item label="전화번호">
                                            <el-input type="text" v-model="form.deliveryTelNo"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="핸드폰">
                                            <el-input type="text" v-model="form.deliveryHpNo"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="24">
                                    <el-col>
                                        <el-form-item label="주소">
                                            <el-row>
                                                <el-col>
                                                    <el-row>
                                                        <el-col :span="6">
                                                            <el-input type="text" v-model="form.zipCd" readonly></el-input>
                                                        </el-col>
                                                        <el-col :span="4">
                                                            <el-button type="primary" icon="el-icon-search" @click="selectAddr">
                                                            </el-button>
                                                        </el-col>
                                                        <el-col :span="14">
                                                            <el-input type="text" v-model="form.addr1"></el-input>
                                                        </el-col>
                                                    </el-row>
                                                </el-col>
                                            </el-row>
                                            <el-row>
                                                <el-col>
                                                    <el-row :gutter="24">
                                                        <el-col :span="24">
                                                            <el-input type="text" v-model="form.addr2"></el-input>
                                                        </el-col>
                                                    </el-row>
                                                </el-col>
                                            </el-row>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </div>
        </div>
        <!-- 결제방법 선택 form e.-->

        <!-- 주문메모 text area s.-->
        <div class="table-area">
            <div class="table-b" style="margin-bottom: 0px;">
                <el-row :gutter="24">
                    <el-col>
                        <div class="sub-title">
                            <div class="table-name">
                                <h3 class="ico_table_name">{{ `주문메모` }}</h3>
                            </div>
                        </div>
                        <el-input
                        type="textarea"
                        :autosize="{ minRows: 4, maxRows: 6}"
                        placeholder="주문메모를 작성하세요."
                        v-model="form.memo">
                        </el-input>
                        <div class="grid-content bg-purple"></div>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col>
                        <div class="sub-title">
                            <div class="table-name">
                                <h3 class="ico_table_name">{{ `주문취소일자` }}</h3>
                            </div>
                        </div>
                        <el-col :span="5">
                            <el-input type="text" v-model="form.cancelDt" readonly></el-input>
                        </el-col>
                        <div class="grid-content bg-purple"></div>
                    </el-col>
                </el-row>
                <div><span class="wave">&nbsp;</span></div>
                <div class="btn-wrap btn-type1 clearfix">
                  <el-button type="primary" icon="el-icon-folder-checked" size="mini" @click="updatePayment">입금</el-button>
                  <el-button type="primary" icon="el-icon-folder-checked" size="mini" @click="updateCancelPayment">입금취소</el-button>
                  <el-button type="primary" icon="el-icon-folder-checked" size="mini" @click="cancelOrder">주문취소</el-button>
                  <el-button type="primary" icon="el-icon-folder-checked" size="mini" @click="updateOrder">수정</el-button>
                </div>
            </div>
        </div>
        <!-- 주문메모 text area e.-->


    </div>
  </div>
</template>

<script>
/**
 * * mixins
 */
 import lucoms from '@/mixin/lucoms';

import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import ReceptionModal_01 from "@/components/AS/History/Modal/ReceptionModal_01";
import InvtItemSelect from '@/components/AS/OrderConsult/Modal/InvtItemSelect';
import BillWrite from '@/components/AS/MateSaleList/BillWrite';

function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

/**
 * 콤마표시
 * @param {*} val 
 */
 function comma(val){
    return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function _phone(hp){
    return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}

export default {
  mixins: [lucoms],
  props: {
  },
  data() {
    return {
      data: [],
      subData: [],
      excelData: [],
      search: {
        companyId : '',
        startDt: this.$moment().add(-7, 'days').format('YYYY-MM-DD'),
        endDt: this.$moment().format('YYYY-MM-DD'),
        dtType: '',                // 기간타입
        orderStatus : '',          // 처리결과
        payBank: '',               // 입금은행
        chkToday: '',              // 오늘의 할일
        custNm : '',               // 주문자명
        orderId : '',              // 주문번호
        selOrderId: '',            // 조회조건의 주문번호
        agentMember: '',           // 상담원
        sortType :  '',
        //processTime : '',
        todayWork: '',
        todo: '',
        page: 1,
        totalpage: 9999,
        totalcount: 9999,
        curPage: 0,
        processTime: '',
        deliveryNoCount: 0        // 배송불가 갯수
      },
      form: {
        orderId: '', // 주문번호
        orderAmt: '0', // 청구금액
        createDt: '', // 주문일시
        payConfirmDt: '', // 입금일자
        custNm: '', // 주문자명
        payBank: '', // 입금은행
        orderTelNo: '', // 연락처
        billYn: '', // 계산서발행
        deliveryAddrId: 0,
        deliveryNm: '', // 받을사람
        deliveryTelNo: '', // 전화번호
        deliveryHpNo: '', // 핸드폰
        zipCd: '', // 
        addr1: '', // 주소
        addr2: '', //
        memo: '', // 주문메모
        cancelDt: '', // 주문취소일자
        orderStatus: '',
        payYn: '', // 입금여부
        delOrderDetailIds: [] // 삭제된 상세ID
      },
      authEditable: false,
      combos: {
        'dtType': [],
        'orderStatus' : [],
        'payBank': [],
        'billYn': [],
        'maker' : [],
        'modelGroup': [],
        'agentMember': []
      },
      startDt: this.$moment().add(-7, 'days').format('YYYY-MM-DD'),
      endDt: this.$moment().format('YYYY-MM-DD'),
      accountPrint: [],         // 세금계산서 발행
      showDeliverySave: false, 
      showDeliveryCancel: false,
      showPrintAccount: false,
      
      // AG-GRID OPTION [START]
      gridStyle : 'padding-top: 40px; width: 100%;height: 400px; min-height:100px;',
      defaultColDef: {
          resizable: true
        , filter:true
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      subGridApi: null,
      subColumnApi: null,
      subGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      excelGridApi: null,
      excelColumnApi: null,
      excelGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
        
        excelStyles: [
          {
              id: 'numberType',
              numberFormat: {
                  format: '0',
              },
          },
          {
              id: 'stringType',
              dataType: 'String',
          },
          {
              id: 'dateType',
              dataType: 'DateTime',
          },
        ],
      },
      context: {
        //checkbox 전체 체크 이벤트 추가
        headerAllCheckEvent: this.allCheckEvnet
      },
      columnDefs: [],
      subColumnDefs: [],
      excelColumnDefs: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      statusBar: null,
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      this.init();
    },
    onReadySub() {
      this.subGridApi = this.subGridOptions.api;
      this.subColumnApi = this.subGridOptions.columnApi;
    },
    onReadyExcel() {
      this.excelGridApi = this.excelGridOptions.api;
      this.excelColumnApi = this.excelGridOptions.columnApi;
    },
    createMainColumnDefs() {
      this.columnDefs = [
        {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'주문일자', field:'createDt', width:100, cellStyle:{textAlign: 'center'}},
        {headerName:'주문번호', field:'orderId', width:100, cellStyle:{textAlign: 'center'}},
        {headerName:'주문자명', field:'boundCustNm', width:100, cellStyle:{textAlign: 'center'}},
        {headerName:'핸드폰', field:'boundTelNo', width:100, cellStyle:{textAlign: 'center'}},
        {headerName:'수취인명', field:'deliveryNm', width:100, cellStyle:{textAlign: 'center'}},
        {headerName:'수취인휴대전화', field:'deliveryHpNo', width:100},
        {headerName:'배송지', field:'addr', width:150, cellStyle:{textAlign: 'left'}},
        {headerName:'품번', field:'orderItemNm', width:100, cellStyle:{textAlign: 'left'}},
        {headerName:'주문금액', field:'orderAmt', width:120, cellStyle:{textAlign: 'right'}},
        {headerName:'입금은행', field:'payBank', width:100, cellStyle:{textAlign: 'center'}, hide: true},
        {headerName:'입금은행', field:'payBankNm', width:100, cellStyle:{textAlign: 'center'}},
        {headerName:'입금일자', field:'payConfirmDt', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'배송일자', field:'deliveryDt', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'주문취소일자', field:'cancelDt', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'처리결과', field:'orderStatusNm', width:180, cellStyle:{textAlign: 'center'}},
        {headerName:'deliveryAddrId', field:'deliveryAddrId', width:180, cellStyle:{textAlign: 'center'}, hide:true},
        {headerName:'deliveryNm', field:'deliveryNm', width:180, cellStyle:{textAlign: 'center'}, hide:true},
        {headerName:'deliveryTelNo', field:'deliveryTelNo', width:180, cellStyle:{textAlign: 'center'}, hide:true},
        {headerName:'deliveryHpNo', field:'deliveryHpNo', width:180, cellStyle:{textAlign: 'center'}, hide:true},
        {headerName:'zipCd', field:'zipCd', width:120, cellStyle:{textAlign: 'center'}, hide:true},
        {headerName:'addr1', field:'addr1', width:120, cellStyle:{textAlign: 'center'}, hide:true},
        {headerName:'addr2', field:'addr2', width:120, cellStyle:{textAlign: 'center'}, hide:true},
        {headerName:'메모', field:'memo', width:230, cellStyle:{textAlign: 'left'}},
        {headerName:'상담원', field:'creatorNm', width:100, cellStyle:{textAlign: 'center'}}
      ];
    },
    createSubColumnDefs() {
      const vm = this;
      this.subColumnDefs = [
        {
            field:'chk', 
            width:80,
            headerComponent: `checkBox`,
            headerComponentParams: (params) => {
              return params;
            },
            cellStyle:{textAlign: 'center'},
            cellRenderer: 'checkBox',
            ellRendererParams: {
                  trueValue: 'Y'    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                , falseValue: 'N'  //false값 지정 defalut-"N" ex) "N", false, "0"
            },
        },
        {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'입력/수정', field:'ioFlag', width:100, cellStyle:{textAlign: 'center'}, hide:true},
        {headerName:'상세ID', field:'orderDetailId', width:100, cellStyle:{textAlign: 'center'}, hide:true},
        {headerName:'제조사', field:'makerNm', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'제조사', field:'maker', width:120, cellStyle:{textAlign: 'center'}, hide: true},
        {headerName:'제품군', field:'itemGroupNm', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'제품군', field:'itemGroup', width:120, cellStyle:{textAlign: 'center'}, hide: true},
        {headerName:'품번', field:'itemCd', width:200, cellStyle:{textAlign: 'center'}},
        {headerName:'품명', field:'itemNm', width:360},
        {headerName:'소비자가', field:'unitPrice', width:110, cellStyle:{textAlign: 'right'},
          valueFormatter: (params) => {
              return vm.getNumberFormat(params.value);
          }
        },
        {headerName:'주문수량', field:'qty', width:110, cellStyle:{textAlign: 'right'},
          editable : (params) => {     
                        return params.data.authEditable;
                    },
          cellStyle:(params) => {               
                        if(params.data.authEditable){
                            return {textAlign: 'right', backgroundColor: '#fff8f7'}
                        }else{
                            return {textAlign: 'right'}
                        }
                    },
          valueFormatter: (params) => {
              return vm.getNumberFormat(params.value);
          }
        },
        {headerName:'금액', field:'amt', width:110, cellStyle:{textAlign: 'right'}, 
          valueFormatter: (params) => {
              return vm.getNumberFormat(params.value);
          }
        },
        {headerName:'받을사람', field:'deliveryNm', width:100, cellStyle:{textAlign: 'center'}},
        {headerName:'핸드폰', field:'deliveryHpNo', width:100, cellStyle:{textAlign: 'center'}},
        {headerName:'메모', field:'memo', width:100, cellStyle:{textAlign: 'left'}}
        
      ];
    },
    createExcelColumnDefs() {
      const vm = this;
      this.excelColumnDefs = [
        {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'주문일자', field:'createDt', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'주문번호', field:'orderId', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'주문자명', field:'boundCustNm', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'배송지핸드폰', field:'deliveryHpNo', width:160, cellStyle:{textAlign: 'center'}},
        {headerName:'배송지 우편번호', field:'zipCd', width:100, cellStyle:{textAlign: 'left'}, cellClass: 'stringType'},
        {headerName:'배송지', field:'addr', width:310, cellStyle:{textAlign: 'left'}},
        {headerName:'수취인명', field:'deliveryNm', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'품번', field:'itemCd', width:150, cellStyle:{textAlign: 'left'}, cellClass: 'stringType'},
        {headerName:'품명', field:'itemNm', width:210, cellStyle:{textAlign: 'left'}},
        {headerName:'주문품번', field:'orderItemNm', width:210, cellStyle:{textAlign: 'left'}},
        {headerName:'주문수량', field:'qty', width:120, cellStyle:{textAlign: 'right'}},
        {headerName:'이평단가', field:'orderAmt', width:120, cellStyle:{textAlign: 'right'}},
        {headerName:'이평금액', field:'orderAmt', width:120, cellStyle:{textAlign: 'right'}},
        {headerName:'주문금액', field:'orderAmt', width:120, cellStyle:{textAlign: 'right'}},
        {headerName:'입금은행', field:'payBank', width:110, cellStyle:{textAlign: 'center'}, hide: true},
        {headerName:'입금은행', field:'payBankNm', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'입금일자', field:'payConfirmDt', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'배송일자', field:'deliveryDt', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'주문취소일자', field:'cancelDt', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'처리결과', field:'orderStatusNm', width:180, cellStyle:{textAlign: 'center'}},
        {headerName:'메모', field:'memo', width:180, cellStyle:{textAlign: 'center'}},
        {headerName:'상담원', field:'creatorNm', width:110, cellStyle:{textAlign: 'center'}}
        
      ];
    },
    onCellClicked(params) {
      //const idx = params.rowIndex;
      this.form.delOrderDetailIds = []; // 초기화
      const field = params.colDef.field;
      this.goDetail(params.data)
    },
    /**
     * 접수/처리 상세 팝업 오픈
     */
    openModel(param) {
      console.log(param);
      let vm = this;
      this.$modal.open({
        width: 800,
        component: ReceptionModal_01,
        parent: this,
        props: {
          data: {
            asId: param.asId,
            custId: param.custId,
            sortType: '',
            popHeadInfo: '', //this.custParam.popHeadInfo,
            //reqDt: this.$moment('20230101').format('YYYY-MM-DD'),
            recptDt: this.$moment(param.callDt).format('YYYY-MM-DD'),
            procsDt: this.$moment(param.procDt).format('YYYY-MM-DD')
          }
        },
        events: {
          close(data) {
            console.log('close', data);
          },
        }
      });
    },
    $dismiss() {
      this.$emit('dismiss')
      this.$parent.close()
    },
    isAuth(){
      this.authEditable = false;
      const auth = this.$store.state.loginInfo.authorities.filter(x=>x.programId===159);
      let Editable = false; // 편집권한
      if(auth && auth.length > 0){
        Editable = auth[0].grantInsert === 'Y' || auth[0].grantUpdate === 'Y' ? true : false ;
      }
      console.log('===Editable1 : ', Editable)
       //입금확인 상태이면 편집불가
      if(this.form.payYn === 'Y'){
        Editable = false;
      }
      console.log('===Editable2 : ', Editable)
      if(this.form.orderStatus !== 'PayN'){
        Editable = false;
      }
      console.log('===Editable3 : ', Editable, this.form.orderStatus)
      if(!Editable){
        // this.$swal({ type: 'warning', text: '편집권한이 없습니다.' });
        return false;
      }

      this.authEditable = true;
      return true;
    },
    async goOpen() {
      // 조회
      this.formClear();
      let vm = this;
      console.log('goOpen passed ');
      this.form.delOrderDetailIds = []; // 초기화
      let vStartDt = this.search.startDt ? this.search.startDt.replace(/[^0-9]/g, '') : '';
      let vEndDt = this.search.endDt ? this.search.endDt.replace(/[^0-9]/g, '') : '';
      if(this.search.dtType === ''){
        vStartDt = '';
        vEndDt = '';
      } 
      
      if(Number(vStartDt) > Number(vEndDt)){
        this.$swal({ type: 'warning', text: '검색 일자를 정확히 입력해주세요.' });
        return false;
      }

      this.search.todayWork = this.search.chkToday;
      this.search.todo = this.search.chkToday === 'Y' ? '1' : '';
        
      this.$store.commit('loading')

      if(this.$route.query.startDt == 'TodayWork'){
        this.search.chkToday = 'Y';
        this.search.todayWork = 'Y';
        this.search.todo = '1';
      }

      const vform = {
        ...this.search,
        agentMember: this.search.agentMember || '0',
        startDt : vStartDt,
        endDt : vEndDt,
        payBank: '',
        page: 1,
        totalpage: 9999,
        totalcount: 9999,
        curPage: 0,
        processTime : ''
      }

      console.log('goOpen vform : ', vform);
      this.search.deliveryNoCount = 0; //초기화
      this.$http.post(_url("/api/asMng/mateSaleList/list"), vform).then(response => {
        console.log('response.data' , response.data)
        this.data = response.data.map(x=>{
          x.orderTelNo = _phone(x.orderTelNo);
          x.billYnNm = x.billYn === 'N' ? '무' : '유';
          x.addr = x.addr1 + ' ' + x.addr2;
          x.createDt = x.createDt && x.createDt.length >=10 ? x.createDt.substring(0,10) : '';  
          x.deliveryDt = x.deliveryDt && x.deliveryDt.length >=10 ? x.deliveryDt.substring(0,10) : '';
          x.payConfirmDt = x.payConfirmDt && x.payConfirmDt.length >=10 ? x.payConfirmDt.substring(0,10) : '';
          x.cancelDt = x.cancelDt && x.cancelDt.length >=10 ? x.cancelDt.substring(0,10) : '';
          x.boundTelNo = _phone(x.boundTelNo);
          x.deliveryHpNo = _phone(x.deliveryHpNo);
          
          const vBankobj = vm.combos['payBank'].filter(y=>y.key===x.payBank);
          if(vBankobj && vBankobj.length > 0){
            x.payBankNm = vBankobj[0].value;
          }

          const vobj = vm.combos['orderStatus'].filter(y=>y.key===x.orderStatus);
          if(vobj && vobj.length > 0){
            x.orderStatusNm = vobj[0].value;
          }
          
          return x;
        })

        if(response.data && response.data.length > 0){
          vm.goDetail({orderId: response.data[0].orderId, deliveryAddrId: response.data[0].deliveryAddrId });
        }

      }).finally(() => {
        this.$store.commit('finish')
      });
    },
    async goDetail(param) {
      // 주문상품목록 조회
      let vm = this
      console.log('goDetail param====', param)
      this.$store.commit('loading')

      const vform = {
        orderId : param.orderId,
        sortType : ''
      }

      this.form.orderId = param.orderId || '';
      this.form.deliveryAddrId = param.deliveryAddrId || 0;
        
      this.search.deliveryNoCount = 0; // 초기화
      await this.$http.post(_url("/api/asMng/mateSaleList/selectItem"), vform).then(response => {
        console.log('subData data : ' , response.data)
        let vAccObj = response.data.accountPrint;
        let vAcc = {};
        if(vAccObj && vAccObj.length>0){ vAcc = vAccObj[0];}
        
        this.form.orderId = vAcc.orderId ; // 주문번호
        this.form.orderAmt = comma(vAcc.orderAmt) ; // 청구금액
        this.form.createDt = vAcc.createDt && vAcc.createDt.length >= 10 ? vAcc.createDt.substring(0,10): ''; // 주문일시
        this.form.payConfirmDt = vAcc.payConfirmDt && vAcc.payConfirmDt.length >= 10 ? vAcc.payConfirmDt.substring(0,10): ''; // 입금일자
        this.form.custNm = vAcc.custNm ; // 주문자명
        this.form.payBank = vAcc.payBank ; // 입금은행
        this.form.orderTelNo = _phone(vAcc.orderTelNo) ; // 연락처
        this.form.billYn = vAcc.billYn ; // 계산서발행
        this.form.deliveryNm = vAcc.deliveryNm ; // 받을사람
        this.form.deliveryTelNo = _phone(vAcc.deliveryTelNo) ; // 전화번호
        this.form.deliveryHpNo = _phone(vAcc.deliveryHpNo) ; // 핸드폰
        this.form.zipCd = vAcc.zipCd || 0;
        this.form.addr1 = vAcc.addr1 ; // 주소
        this.form.addr2 = vAcc.addr2 ; // 주소
        this.form.memo = vAcc.memo ; // 주문메모
        this.form.cancelDt = vAcc.cancelDt && vAcc.cancelDt.length>=10  ? vAcc.cancelDt.substring(0,10) : '' ; // 주문취소일자
        this.form.orderStatus = vAcc.orderStatus || '';
        this.form.payYn = vAcc.payYn || '';
        
        this.isAuth();
         
        this.subData = response.data.selectDetailSel.map((x, index)=>{
          
          x.createDt = x.createDt && x.createDt.length >=10 ? x.createDt.substring(0,10) : '';  

          const vMObj = this.combos['maker'].filter(y=>y.key===x.maker);
          x.makerNm = vMObj && vMObj.length>0 ? vMObj[0].value : '';

          const vModelGroupObj = this.combos['modelGroup'].filter(y=>y.key===x.modelGroup);
          x.modelGroupNm = vModelGroupObj && vModelGroupObj.length>0 ? vModelGroupObj[0].value : '';

          x.deliveryNm = this.form.deliveryNm;
          x.deliveryHpNo = this.form.deliveryHpNo;
          x.memo = vAcc.memo;

          x.ioFlag = 'U' ; // 입력(I),수정(U)

          if(index === 0){
              
              const vPObj = vm.accountPrint;
              const vOrderStatus = vPObj && vPObj.length>0? vPObj[0].orderStatus : '';
              const vBillYn = vPObj && vPObj.length>0? vPObj[0].billYn : '';

              if(vm.search.deliveryNoCount === 0 && vOrderStatus=== 'PayY' ){
                vm.showDeliverySave = true;
                vm.showPrintAccount = false;
                vm.showDeliveryCancel = false;

              } else if(vOrderStatus === 'DeliveryY' ){
                vm.showDeliveryCancel = true;
                vm.showDeliverySave = false;

                if(vBillYn === 'Y')
                  vm.showPrintAccount = true;
                else
                  vm.showPrintAccount = false;
              } else {
                vm.showDeliveryCancel = false;
                vm.showPrintAccount = false;
                vm.showDeliverySave = false;
              }
  
          } 

          x.authEditable = vm.authEditable;

          return x;
        });
        
        console.log('this.subData====end ;;;', this.subData)


      }).finally(() => {
        this.$store.commit('finish')
      });
    },
    save() {
      console.log('test',this.$parent.$refs.step.next())
    },
    btnItemAdd(){
      // 주문상품목록 추가

      if(this.form.orderId === '' || this.form.orderId === '0'){
        this.$swal({ type: 'warning', text: '먼저 조회를 하신후에 주문 내역을 선택해 주세요.' });
        return false;
      }

      let vm = this;
      this.$modal.open({
          width: 800,
          component: InvtItemSelect,
          parent: this,
          props: {
              data: {
                  centerCd: '01',
                  prodCd1: '',
                  prodCd2: '',
                  gb: '구분코드',
                  prodNo: '품번'
              }
          },
          events: {
              close(vRetData) {
                  console.log('close', vRetData);
                  let allItemIds = '' // 기존의 품목ID들
                  vm.subData.map(x=>{
                      allItemIds += x.itemId + ',' 
                      return x
                  })

                  //이미 추가한 품목은 제외시킴
                  let vvRetData2 = (allItemIds === '') ? vRetData : ( vRetData.filter(x=>allItemIds.indexOf(x.itemId + ',') == -1) )
 
                  const vData = vvRetData2.map(x=>{
                      x.orderId = vm.form.orderId;
                      x.qty = 1;
                      x.unitPrice = (x.unitPrice3); // 소비자가
                      
                      let vUnitPrice = x.unitPrice3;
                      if(vUnitPrice && vUnitPrice.length >0 ){
                        vUnitPrice = vUnitPrice.replace(/[^0-9]/g, "")
                      }
console.log('====vUnitPrice: ', vUnitPrice)
                      x.amt = x.unitPrice3 ? (Number(vUnitPrice) * Number(x.qty)) + '' : ''; // 금액 = (소바자가 * 주문수량)
                      x.amt = comma(x.amt);
                      x.ioFlag = 'I'; // 입력(I),수정(U)
                      x.authEditable = vm.authEditable;

                      return x
                  }) || []

                  const vSumArr = vm.subData.concat(vData)
                  vm.subData = vSumArr

                  // vm.calcAmt()
                  // vm.qtyChangeCnt++


                  
              },
          }
      });
      
    },
    btnItemDelete(){
      // 주문상품목록 삭제
console.log('btnItemDelete start ::::')
      let vSrcObj = this.subData;
      let chkedObj = vSrcObj.filter(x=>x.chk==='Y');
      
      if(!vSrcObj || chkedObj.length === 0){
          this.$swal({
          type: 'warning',
          text: '선택된 행이 없습니다.'
          });

          return false;
      }

      // 삭제ITEM의 상세키값 저장
      const vm = this;
      chkedObj.map(x=>{
        if(x.orderDetailId != null){
          vm.form.delOrderDetailIds.push(x.orderDetailId);
        }
        
        return x;
      });
      
      const vLiveObj = vSrcObj.filter(x=>x.chk!='Y');
      this.subData = vLiveObj;
    },
    SubCellValueChange(params){
      /** 주문상품목록 셀변경시 */
      const subIdx = params.rowIndex;
      let vUnitPrice = params.data.unitPrice;
      if(vUnitPrice && vUnitPrice.length >0 ){
        vUnitPrice = vUnitPrice.replace(/[^0-9]/g, "")
      }

      if(params.colDef.field === 'qty'){
        const vsum = Number(params.value) * Number(vUnitPrice);
        if((vsum+'') === 'NaN'){
          params.data.amt = '0';
          this.subGridApi.redrawRows({ rowNodes: params });

          this.$swal({ type: 'warning', text: '주문수량에 숫자만 입력해주세요.' });
          return false;
        }

        params.data.amt = vsum + '';

        let vAllSum = 0;
        this.subData.map(x=>{
          const vamt = x.amt;
          if(vamt && vamt.length>0){
            vAllSum = vAllSum + Number(vamt.replace(/[^0-9]/g, ""));
          }
          
          return x;
        });

        this.form.orderAmt = comma(vAllSum);
        
        this.subGridApi.redrawRows({ rowNodes: params });

      }
      
  },
    btnBillWrite(){
      // 발행정보등록
      console.log("btnBillWrite start")
      
      if(this.form.orderId === '' || this.form.orderId === '0'){
        this.$swal({ type: 'warning', text: '주문 내역을 선택해 주세요.' });
        return false;
      }
 
      if(this.form.orderStatus === 'OrderCancel' || this.form.payYn === 'Y'){
        this.$swal({ type: 'warning', text: "'주문취소' 또는 '입금완료' 가 된 주문은 입금을 할 수 없습니다."});
        return false;
      }

      if(this.form.payBank === ''){
        this.$swal({ type: 'warning', text: '입금은행 선택해 주십시오.'});
        return false;
      }

      if(this.form.billYn != 'Y'){
        this.$swal({ type: 'warning', text: "계산서발행을 '유' 로 체크해주세요"});
        return false;
      }
      

      let vm = this;
      this.$modal.open({
          width: 800,
          component: BillWrite,
          parent: this,
          props: {
              data: {
                orderId: vm.form.orderId
              }
          },
          events: {
              close(data) {
                  console.log('close', data);
              },
          }
      });
       
    },
    async init() {
      this.$store.commit('loading');
      
      // 제조사
      await this.$http.get(`/api/codeMng/combo`, {params: {parentId: 196}})
        .then(response => {
          this.combos['maker'] = response.data || []
        });

      // 제품군 : ModelGroup, CAT_LVL(2)
      await this.$http.get(`/api/codeMng/combo`, {params: {parentId: 143}})
        .then(response => {
          this.combos['modelGroup'] = response.data || []
        });
              
      // 기간타입 : DateType   
      await this.$http.get(`/api/codeMng/combo`, {params: {parentId: 261}})
        .then(response => {
          this.combos['dtType'] = response.data || [];

          this.search.dtType = 'Call_DT';
        });

      // 처리결과 : OrderStatus
      await this.$http.get(`/api/codeMng/combo`, {params: {parentId: 265}})
        .then(response => {
          this.combos['orderStatus'] = 
            response.data
              .filter(x=>x.key!=='DeliveryY') || [];
        });

      // 입금은행 : PayBank 
      await this.$http.get(`/api/codeMng/combo`, {params: {parentId: 106}})
        .then(response => {
          console.log('response.data payBank ddd: ', response.data)
          this.combos['payBank'] = response.data || [];
        });
      
      // 계산서발행유무 : BillYn 2레벨
      await this.$http.get(`/api/codeMng/combo`, {params: {parentId: 131}})
        .then(response => {
          this.combos['billYn'] = response.data || [];
        });    

      // 상담원
      await this.$http.post(`/api/asMng/happyCallList/agentList`, {
          ctiType: 'CampaignCustUseUser',
          ctiYn: 'Y',
          userId: this.$store.state.loginInfo.id
        })
          .then((response) => {
              console.log('agentMember response :', response.data)
              this.combos['agentMember'] = response.data.map(x=>{
                x.key = x.userId;
                x.value = x.userNm;
                return x;
              }) || [];

              if(this.$store.state.loginInfo.groupUId==3 || this.$store.state.loginInfo.groupUId==6) {
                this.search.agentMember = this.$store.state.loginInfo.id + '';
              } 

          });  

      this.createMainColumnDefs();
      this.createSubColumnDefs(); // 주문상품목록
      this.createExcelColumnDefs();

      this.$store.commit('finish');
      
      this.goOpen();

    },
    selectAddr(){
      const vm = this;
      // eslint-disable-next-line no-undef
      new daum.Postcode({
          oncomplete: (data) => {
              var fullAddr = data.address; //최종 주소 변수
              var extraAddr = ''; // 조합형 주소 변수
        
              if(data.userSelectedType === 'R') {
                  if(data.bname) {
                      extraAddr += data.bname;
                  }
                  if(data.buildingName) {
                      extraAddr += (extraAddr ? ', '+ data.buildingName : data.buildingName);
                  }
                  fullAddr += (extraAddr ? ' ('+ extraAddr + ')' : '');
              } else {
                  fullAddr = data.jibunAddress;
              }
              console.log(data)
              vm.form.zipCd = data.zonecode;
              vm.form.addr1 = fullAddr;
              vm.form.addr2 = ''; // 초기화
          }
      }).open();
    },
    updatePayment(){
      // 입금처리
      const vm = this;

      if(this.form.orderId === '' || this.form.orderId === '0'){
        this.$swal({ type: 'warning', text: '주문 내역을 선택해 주세요.' });
        return false;
      }
 
      if(this.form.orderStatus === 'OrderCancel' || this.form.payYn === 'Y'){
        this.$swal({ type: 'warning', text: "'주문취소' 또는 '입금완료' 가 된 주문은 입금을 할 수 없습니다."});
        return false;
      }

      if(this.form.payBank === ''){
        this.$swal({ type: 'warning', text: '입금은행 선택해 주십시오.'});
        return false;
      }

      let saveMsg = '입금내역을 저장 하시겠습니까?';
      if(this.form.payYn === 'Y'){
        saveMsg = '입금내역을 수정 하시겠습니까?';
      }
      
      this.$swal({
          type: 'warning',
          text: saveMsg,
          showCancelButton: true,
          confirmButtonText: '예',
          cancelButtonText: '아니오',
      }).then((result) => {
          if (result.value) {
              const vform0 = {
                ...vm.search,
                agentMember: this.search.agentMember || '0',
                ...vm.form
              }

              const vform = JSON.parse(JSON.stringify(vform0))
              
              vm.$store.commit('loading')
              vm.$http.put(_url("/api/asMng/mateSaleList/updatePayment"), vform)
                  .then(response => {
                      vm.$swal({ type: 'success', text: '입금내역이 저장되었습니다.' });
                      
                  }).catch((e) => {
                      console.error(e);
                      vm.$swal({ type: 'success', text: '입금내역 저장에 실패 하였습니다.' })
                  })
                  .finally(() => {
                      vm.$store.commit('finish')
                      vm.formClear();
                      vm.goOpen();
                  });
          }
      });  
    },
    updateCancelPayment(){
      // 입금취소처리
      let vm = this;

      if(this.form.orderId === '' || this.form.orderId === '0'){
        this.$swal({ type: 'warning', text: '주문 내역을 선택해 주세요.' });
        return false;
      }

      if(this.form.cancelDt !== ''){
        this.$swal({ type: 'warning', text: '이미 주문취소가 된 주문 내역입니다.' });
        return false;
      }

      if(this.form.payYn === 'N'){
        this.$swal({ type: 'warning', text: "'입금완료' 가 된 주문이 없습니다."});
        return false;
      }

      if(this.form.orderStatus === 'DeliveryY'){
        this.$swal({ type: 'warning', text: "'배송완료' 가 된 주문은 입금취소를 할 수 없습니다."});
        return false;
      }

      let saveMsg = '입금내역을 취소 하시겠습니까?';
      
      this.$swal({
          type: 'warning',
          text: saveMsg,
          showCancelButton: true,
          confirmButtonText: '예',
          cancelButtonText: '아니오',
      }).then((result) => {
          if (result.value) {
              const vform0 = {
                ...vm.search,
                ...vm.form,
                agentMember: this.search.agentMember || '0',
                cancelDt: vm.$moment().format('YYYY-MM-DD') + ' 00:00:00'
              }

              const vform = JSON.parse(JSON.stringify(vform0))
              console.log('vform: ', vform)
              vm.$store.commit('loading')
              vm.$http.put(_url("/api/asMng/mateSaleList/updateCancelPayment"), vform)
                  .then(response => {
                      vm.$swal({ type: 'success', text: '입금내역이 취소되었습니다.' });
                      
                  }).catch((e) => {
                      // console.error(e);
                      // vm.$swal({ type: 'success', text: '입금내역 저장에 실패 하였습니다.' })
                  })
                  .finally(() => {
                      vm.$store.commit('finish')
                      vm.formClear();
                      vm.goOpen();
                  });
          }
      });  
    },
    cancelOrder(){
      // 주문취소

      if(this.form.orderId === '' || this.form.orderId === '0'){
        this.$swal({ type: 'warning', text: '주문 내역을 선택해 주세요.' });
        return false;
      }

      if(this.form.cancelDt !== ''){
        this.$swal({ type: 'warning', text: '이미 주문취소가 된 주문 내역입니다.' });
        return false;
      }

      this.$swal({
          type: 'warning',
          text: `주문을 취소하시겠습니까?`,
          showCancelButton: true,
          confirmButtonText: '예',
          cancelButtonText: '아니오',
      }).then((result) => {
          if (result.value) {
              const vform0 = {
                ...this.search,
                agentMember: this.search.agentMember || '0',
                ...this.form,
                cancelDt: this.$moment().format('YYYY-MM-DD') + ' 00:00:00'
              }

              const vform = JSON.parse(JSON.stringify(vform0))
              
              this.$store.commit('loading')
              this.$http.put(_url("/api/asMng/mateSaleList/cancelOrder"), vform)
                  .then(response => {
                      this.$swal({ type: 'success', text: '주문을 취소했습니다.' });
                      this.formClear();
                      this.goDetail(vform0);
                  }).catch((e) => {
                      console.error(e);
                      this.$swal({ type: 'success', text: '주문취소를 실패했습니다' })
                  })
                  .finally(() => {
                      this.$store.commit('finish')
                  });
          }
      });

    },
    updateOrder(){
      // 주문수정

      if(this.form.orderId === '' || this.form.orderId === '0'){
        this.$swal({ type: 'warning', text: '주문 내역을 선택해 주세요.' });
        return false;
      }
      
      if(this.form.cancelDt !== ''){
        this.$swal({ type: 'warning', text: '이미 주문취소가 된 주문 내역입니다.' });
        return false;
      }

      if(this.form.deliveryTelNo == ''){
        this.$swal({ type: 'warning', text: '전화번호를 입력해 주십시오.' });
        return false;
      }

      if(this.form.deliveryHpNo == ''){
        this.$swal({ type: 'warning', text: '핸드폰번호를 입력해 주십시오.' });
        return false;
      }

      if(this.form.zipCd == ''){
        this.$swal({ type: 'warning', text: '우편번호를 입력해 주십시오.' });
        return false;
      }

      if(this.form.addr1 == ''){
        this.$swal({ type: 'warning', text: '주소를 입력해 주십시오.' });
        return false;
      }

      if(this.form.addr2 == ''){
        this.$swal({ type: 'warning', text: '상세주소를 입력해 주십시오.' });
        return false;
      }

      this.$swal({
          type: 'warning',
          text: `배송지를 수정하시겠습니까?`,
          showCancelButton: true,
          confirmButtonText: '예',
          cancelButtonText: '아니오',
      }).then((result) => {
          if (result.value) {
              const vSubData0 = this.subData;
              const vSubData = vSubData0.map(x=>{
                const vuprice = x.unitPrice;
                if(vuprice && vuprice.length>0){
                  x.unitPrice = vuprice.replace(/[^0-9]/g, "")
                }

                const vqty = x.qty;
                if(vqty && vqty.length>0){
                  x.qty = vqty.replace(/[^0-9]/g, "")
                }

                const vamt = x.amt;
                if(vamt && vamt.length>0){
                  x.amt = vamt.replace(/[^0-9]/g, "")
                }
              
                return x;
              })
                
              const vform0 = {
                ...this.search,
                agentMember: this.search.agentMember || '0',
                ...this.form,
                deliveryTelNo: this.form.deliveryTelNo ? this.form.deliveryTelNo.replace(/[^0-9]/g, "") : '',
                deliveryHpNo: this.form.deliveryHpNo ? this.form.deliveryHpNo.replace(/[^0-9]/g, "") : '',
                subData: vSubData
              }

              const vform = JSON.parse(JSON.stringify(vform0))
              console.log('save ...vform: ', vform)             
              this.$store.commit('loading')
              this.$http.put(_url("/api/asMng/mateSaleList/updateOrder"), vform)
                  .then(response => {
                      this.$swal({ type: 'success', text: '주문정보를 수정했습니다.' });
                      this.formClear();
                      this.goDetail(vform0);
                  }).catch((e) => {
                      console.error(e);
                      this.$swal({ type: 'success', text: '주문정보 수정에 실패했습니다' })
                  })
                  .finally(() => {
                      this.$store.commit('finish')
                  });
          }
      });

    },
    formClear(){
      // 폼내용 초기화
      this.form.orderId = '0' ; // 주문번호
      this.form.orderAmt = '' ; // 청구금액
      this.form.createDt = ''; // 주문일시
      this.form.payConfirmDt = ''; // 입금일자
      this.form.custNm = ''; // 주문자명
      this.form.payBank = '' ; // 입금은행
      this.form.orderTelNo = '' ; // 연락처
      this.form.billYn = 'N' ; // 계산서발행
      this.form.deliveryNm = '' ; // 받을사람
      this.form.deliveryTelNo = '' ; // 전화번호
      this.form.deliveryHpNo = '' ; // 핸드폰
      this.form.zipCd = '' ; // 
      this.form.addr1 = '' ; // 주소
      this.form.addr2 = '' ; // 주소
      this.form.memo = '' ; // 주문메모
      this.form.cancelDt = '' ; // 주문취소일자
      this.form.orderStatus = '';
      this.form.payYn = '';
    },
    excelDown(){
      this.$store.commit('loading')

      let vStartDt = this.search.startDt ? this.search.startDt.replace(/[^0-9]/g, '') : '';
      let vEndDt = this.search.endDt ? this.search.endDt.replace(/[^0-9]/g, '') : '';

      const vform = {
        ...this.search,
        agentMember: this.search.agentMember || '0',
        startDt : vStartDt,
        endDt : vEndDt,
        payBank: '',
      }

      console.log('excelDown pass vform: ', vform);
      this.search.deliveryNoCount = 0; //초기화
      this.$http.post(_url("/api/asMng/mateSaleList/selectExcelItem"), vform).then(response => {
        console.log('excelDown response.data' , response.data)
        this.excelData = response.data.map((x, index)=>{
          x.no = index + 1;
          
          x.addr = x.addr1 + ' ' + x.addr2;
          x.createDt = x.createDt && x.createDt.length>=19 ? x.createDt.substring(0,19) : '';
          x.cancelDt = x.cancelDt && x.cancelDt.length>=10 ? x.cancelDt.substring(0,10) : '';
          x.payConfirmDt = x.payConfirmDt && x.payConfirmDt.length>=10 ? x.payConfirmDt.substring(0,10) : '';
          x.deliveryDt = x.deliveryDt && x.deliveryDt.length >=10 ? x.deliveryDt.substring(0,10) : '';
          x.deliveryHpNo = _phone(x.deliveryHpNo) || '';
          
          const vobj = this.combos['orderStatus'].filter(y=>y.key===x.orderStatus);
          if(vobj && vobj.length > 0){
            x.orderStatusNm = vobj[0].value;
          }
          
          return x;
        }); 

      }).finally(() => {
        this.$store.commit('finish');

        var params = {
          fileName : "자재판매리스트"
        };
        this.excelGridOptions.api.exportDataAsExcel(params);

      });
      
    },
    /**
     * grid 내에 체크박스 전체 체크 함수
     * @param {*} field 
     * @param {*} checked 
    */
    allCheckEvnet(field, checked) {
      return this.subData = this.subData.map(x => {
          x[field] = checked ? 'Y' : 'N';
          return x;
      })
    },

  },
  created() {

    if(this.$route.query.startDt == 'TodayComplete'){
      this.search.startDt = this.$moment().format('YYYY-MM-DD');
      this.search.dtType = 'Call_DT';
    }else if(this.$route.query.startDt == 'TodayWork'){
      this.search.startDt = '';
      this.search.dtType = 'Call_DT';
    }

    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    console.log('search', this.search);
    this.search.companyId = this.$store.state.loginInfo.compCd;
  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>


<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>